import { useStaticQuery, graphql } from "gatsby"

export const useSitePage = () => {
  const allPages = useStaticQuery(
    graphql`
      query {
        allNodePage {
          edges {
            node {
              field_affichage_planifie
              field_date_de_depublication(
                formatString: "DD/MM/YYYY"
                locale: "fr"
              )
              field_date_de_publication(
                formatString: "DD/MM/YYYY"
                locale: "fr"
              )
              title
              path {
                alias
              }
            }
          }
        }
        allDirectLinkEntityDirectLinkEntity(
          filter: {
            relationships: {
              direct_link_type: { name: { eq: "acces_direct" } }
            }
            highlight: { eq: true }
          }
        ) {
          edges {
            node {
              name
              url {
                uri
              }
            }
          }
        }
        allNodeEvenements {
          edges {
            node {
              path {
                alias
              }
              field_affichage_planifie
              field_date_de_depublication(
                formatString: "DD/MM/YYYY"
                locale: "fr"
              )
              field_date_de_publication(
                formatString: "DD/MM/YYYY"
                locale: "fr"
              )
              title
            }
          }
        }
        allNodeCarnetDAdresse {
          edges {
            node {
              path {
                alias
              }
              title
            }
          }
        }
        allNodeTeleformulaires {
          edges {
            node {
              path {
                alias
              }
              title
            }
          }
        }
        allNodeActualites {
          edges {
            node {
              path {
                alias
              }
              field_affichage_planifie
              field_date_de_depublication(
                formatString: "DD/MM/YYYY"
                locale: "fr"
              )
              field_date_de_publication(
                formatString: "DD/MM/YYYY"
                locale: "fr"
              )
              title
            }
          }
        }
        allSitePage(filter: { path: { regex: "/^((?!404).)*$/" } }) {
          edges {
            node {
              path
              context {
                baseLink
                currentPage
                limit
                nodesLength
                numPages
                skip
                slug
                slugTerm
              }
            }
          }
        }
      }
    `
  )
  return allPages
}
